import { DEFAULT_FILL_COLOR, DEFAULT_STROKE_COLOR } from "./constants";

const getCurrentData = (data, storageData) => {
    return storageData
        && storageData.timestamp
        && storageData.timestamp > data.timestamp
        ? storageData
        : data;
}

const migrate = (data, storageData = null) => {
    if (!data) {
        return {};
    }
    let currentData = getCurrentData(data, storageData);
    if (!currentData.version || currentData.version == 0) {
        return migrateToV1(currentData, data);
    }
    return currentData;
}

const migrateToV1 = (currentData, data) => {
    let newData = {
        name: currentData.name ? currentData.name : data.name,
        elements: migratePlantsToV1(currentData.plants == [] ? data.plants : currentData.plants).concat(migrateShapesToV1(currentData.shapes == [] ? data.shapes : currentData.shapes)),
        settings: currentData.settings == {} ? data.settings : currentData.settings,
        view: migrateViewToV1(currentData.view == {} ? data.view : currentData.view),
        species: currentData.species == {} ? data.species : currentData.species,
        showMigrationMessage: true,
    }
    if (!newData.settings.name) {
        newData.settings.name = newData.name;
    }
    return newData;
}

const migratePlantsToV1 = (plants = []) => {
    return plants.map((plant) => {
        let label = plant.label;
        return {
            type: 'ellipse',
            data: {
                x: plant.x,
                y: plant.y,
                width: plant.size * 100,
                height: plant.size * 100,
                labels: label && label != '' ? [label] : [],
                labelX: 0,
                labelY: 0,
                fillColor: DEFAULT_FILL_COLOR,
                strokeColor: null,
                strokeWidth: null,
            },
            speciesIds: [plant.plant_id],
        };
    });
}

const migrateShapesToV1 = (shapes = []) => {
    return shapes.map((shape) => {
        let label = shape.data.label;
        return {
            type: shape.type,
            data: Object.assign(
                shape.data,
                {
                    fillColor: null,
                    strokeColor: DEFAULT_STROKE_COLOR,
                    strokeWidth: null,
                },
                {
                    labels: label && label != '' ? [label] : [],
                    labelX: 0,
                    labelY: 0,
                }
            ),
            speciesIds: [],
        };
    });
}

const migrateViewToV1 = (view = {}) => {
    return view.zoomLevel == undefined
        ? {}
        : {
            scale: 1.2 ** view.zoomLevel,
            posX: view.posX,
            posY: view.posY,
        }
}

export { migrate };
